import script from "./ContactMaps.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactMaps.vue?vue&type=script&setup=true&lang=js"

import "./ContactMaps.vue?vue&type=style&index=0&id=3d54825d&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d54825d"]])

export default __exports__